module.exports = __webpack_public_path__ + "static/media/watching.54247fcd.gif";